export class EventManager{
    private static LocalEvent:LocalEventManager=null;

    public static GetInstance():LocalEventManager{
        if((window as any).RNLocalEvent==null)
            (window as any).RNLocalEvent=new LocalEventManager();
        return (window as any).RNLocalEvent;
    }

    public static Publish<T extends EventBase>(event:T,defaultValue:any=null):T['ReturnType']{
        return EventManager.GetInstance().Publish<T>(event,defaultValue);
    }


    public static Subscribe<T extends EventBase>(event:{new(...any):T},callBack:(args?:T)=>void,priority=0,reference:any=null)
    {
        EventManager.GetInstance().Subscribe(event,callBack,priority,reference);
    }


    public static SubscriptionCount<T extends EventBase>(event:{new(...any):T})
    {
        let eventName=(event as any).GetName();
        let eventList=EventManager.GetInstance().Events[eventName];
        if(eventList==undefined)
            return 0;
        return eventList.length;

    }


    public static UnsubscribeEvent<T extends EventBase>(event:{new(...any):T},callBackOrReference:((args?:T)=>void)|any)
    {
        EventManager.GetInstance().UnsubscribeEvent(event,callBackOrReference);
    }
}


export class LocalEventManager{

    public Events:any={};

    public Publish<T extends EventBase>(event:T,defaultValue:any=null):T['ReturnType']{
        let eventName=(event.constructor as any).GetName();
        if(this.Events[eventName]==null)
            return defaultValue;

        let eventsToCall:EventItem[]=this.Events[eventName];
        let result=null;
        for(let eventToCall of eventsToCall) {
            let aux;
            aux = eventToCall.CallBack(event);
            if(aux!=null)
                result=aux;
        }

        if(result==null) {
            return event.GetReturnType()!==null?event.GetReturnType(): defaultValue;
        }
        return result;
    }


    public Subscribe<T extends EventBase>(event:{new():T},callBack:(args?:T)=>void,priority=0,reference:any)
    {
        let eventName=(event as any).GetName();
        if(this.Events[eventName]==null)
        {
            this.Events[eventName]=[];
        }

        let eventList:EventItem[]=this.Events[eventName];
        let newEvent=new EventItem(event as any,callBack,priority,reference);

        for(let i=0;i<eventList.length;i++)
        {
            if(eventList[i].Priority>newEvent.Priority)
            {
                eventList.splice(i,0,newEvent);
                newEvent=null;
                break;
            }
        }

        if(newEvent!=null)
            eventList.push(newEvent);

    }

    public UnsubscribeEvent<T extends EventBase>(event:{new(...any):T},callBackOrReference:((args?:T)=>void)|any)
    {
        let eventName=(event as any).GetName();
        let events:EventItem[]=this.Events[eventName];
        if(events==null)
            return;

        let item=events.find(x=>x.CallBack==callBackOrReference||x.Reference==callBackOrReference);
        if(item!=null)
            events.splice(events.indexOf(item),1);

        if(events.length==0)
            delete this.Events[eventName];

    }
}

class EventItem<T=any>{
    Event:EventBase;
    CallBack:(args?:T)=>void|any;
    Priority:any;

    Reference:any;
    protected ReturnType:T;

    constructor(event:EventBase,callBack:(args?:T)=>void|any,priority=0,reference:any=null)
    {
        this.Event=event;
        this.CallBack=callBack;
        this.Priority=priority;
        this.Reference=reference;
    }
}




export abstract class EventBase{
    public ReturnType:any;
    public static GetName(){
        throw new Error('Name was not defined');
    }

    public GetReturnType():this['ReturnType']{
        return null;
    }

}